import React from "react";
import SeoText from "./seoText.tsx";

interface IState {
    bannerHtml: any
}

class SeoFooter extends React.Component {
    private readonly seoFooterContainerRef: React.RefObject<HTMLDivElement>;

    readonly state: IState;

    private observer: any;

    constructor(props: any) {
        super(props);

        this.state = {
            bannerHtml: undefined
        };

        this.seoFooterContainerRef = React.createRef();
    }

    componentDidMount() {
        this.setSeoContent();
        this.startResizeSeoFooterObserver();
        (this.props as any).history?.listen(() => {
            this.setSeoContent();
        });
    }

    getSeoContentUrl() {
        const urlParts = window.location.pathname.replace(configurationSettings?.webRoot, "").trimEnd().split("/");
        const mode = urlParts[0];
        const lastParts = urlParts[urlParts.length - 1].split("-");
        const eventId = +lastParts[lastParts.length - 1];

        let suffix = mode || "home";
        if (eventId && !isNaN(eventId)) {
            suffix += "-" + eventId;
        }

        return `${GBEglobal?.settings.banners?.root}seo-${suffix}.html`;
    }

    setSeoContent() {
        const url = this.getSeoContentUrl();

        if (url) {
            fetch(url).then((res) => {
                if (res.ok) {
                    return res.text();
                }
            }).then((data) => {
                this.setBannerState(data);
            }).catch((err) => {
                console.error(`Error With SEOFooter: ${err.message}`);
            });
        } else {
            this.setBannerState(null);
        }
    }

    componentWillUnmount() {
        this.removeObserver();
    }

    removeObserver() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    setBannerState(newState: any, callBack?: any) {
        this.setState({
            bannerHtml: newState
        }, callBack);
    }

    getElement(mode: any) {
        if (mode === -1 /* Casino Mode */) {
            return document?.querySelector(".gameselectors");
        } else {
            return document?.querySelector("#centerPanel");
        }
    }

    startResizeSeoFooterObserver() {
        const mode = GBEglobal?.mode;

        if (this.observer) {
            return;
        }
        this.observer = new ResizeObserver(() => {
            this.resizeSeoFooter(mode);
        });

        try {
            this.observer.observe(document.querySelector("#container"));
        } catch (e: any) {
            console.error(`SEOFooter Resize Observer\nCould Not Start: ${e.message}`);
        }
    }

    resizeSeoFooter(mode: any) {
        const el = this.getElement(mode);
        if (el && this.seoFooterContainerRef) {
            let leftNav = null;
            let gamesComponent = null;
            let mainBodyRow = null;
            let centerPanel = null;

            try {
                mainBodyRow = $("#mainBodyRow").offset();
                leftNav = document?.querySelector("#leftPanel");
                centerPanel = window.getComputedStyle(document.querySelector("#centerPanel")!);
                gamesComponent = window.getComputedStyle(document.querySelector(".gamescomponent")!);
            } catch (e) {
                // ignore
            }
            const { current: seoContainer } = this.seoFooterContainerRef;

            let calculatedMarginLeft = leftNav !== null ? leftNav.clientWidth : 0;
            calculatedMarginLeft += mainBodyRow !== null ? +(mainBodyRow?.left || 0) : 0;
            calculatedMarginLeft += centerPanel !== null ? +(centerPanel.paddingLeft.replace("px", "")) : 0;
            calculatedMarginLeft += gamesComponent !== null ? +(gamesComponent.paddingLeft.replace("px", "")) : 0;

            seoContainer?.setAttribute("style", `
                    width: ${calculatedMarginLeft !== 0 ? el.clientWidth + "px" : "auto"} !important;
                    margin-left: ${calculatedMarginLeft}px !important;
                `);
        }
    }

    render() {
        const { bannerHtml } = this.state;

        return (
            <>
                {
                    (bannerHtml) ? (
                        <div className="seo-footer-container" ref={this.seoFooterContainerRef}>
                            <div className="seo-footer">
                                <SeoText text={bannerHtml} />
                            </div>
                        </div>
                    ) : null
                }
            </>
        );
    }
}
export default SeoFooter;